import { observer } from "mobx-react-lite";
import React from "react";
import { ReactComponent as LogoSvg } from "../../../../assets/altlogo.svg";
import styles from "./styles.module.css";
import { Button } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";

const LinkExpired = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.mainDiv}>
      <div className={styles.cardStyle}>
        <LogoSvg />
        <p className={styles.cardText}>
          <b>Link Expired</b>
        </p>
        <p className={styles.cardText}>
          The requested link has expired. Please contact the admin for further
          assistance.
        </p>
        <Button onClick={() => navigate("/login")} primary>
          Go to login Page
        </Button>
      </div>
    </div>
  );
};

export default observer(LinkExpired);
